<template>
    <div class="numberspilt-box">
        <div v-for="(item, index) in splitNumerStr(val)" :key="'num_split' + index" class="numberspilt-box-item">{{ item }}</div>
    </div>
</template>

<script>
export default {
    props: ["val"],
    data() {
        return {

        }
    },
    methods: {
        splitNumerStr(num) {
            let tmp = String(num);
            tmp.split("");
            return tmp
        }
    }
}
</script>

<style lang="scss" scoped>
.numberspilt-box {
    display: flex;
    flex-direction: row;
    align-items: center;

    .numberspilt-box-item {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-right: 7px;
        width: 23px;
        height: 27px;
        border-radius: 4px;
        opacity: 1;
        box-sizing: border-box;

        background: rgba(10, 162, 107, 0.2);

        box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
        font-family: Oswald;
        font-size: 20px;
        font-weight: normal;
        line-height: 27px;

        font-feature-settings: "kern" on;
        /* 绿 */
        color: #0AA26B;

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>